import ALLERGOMEDICA_LOGO from './images/allergomedica_logo.svg';
import SELFCO_LOGO from './images/selfco_logo.svg';

const IMAGES = {
  LOGOTYPES: {
    PRIMARY: ALLERGOMEDICA_LOGO,
    SELFCO: SELFCO_LOGO,
  },
};

export default IMAGES;
